import Typography from 'components/Typography';
import { useAnalytics } from 'hooks/useAnalytics';

import { ANALYTICS } from 'analytics/constants';
import { CHAT_UI_PREFIX } from 'constants/id';
import { AnalyticClickedLinkDetailsType } from 'analytics/types';
import { MoreLikeThisCardProps } from './types';
import { ViewMoreContainer } from './styles';
import { open } from 'utils/url';

const MoreLikeThisCard = (props: MoreLikeThisCardProps) => {
  const { action, title } = props.vehicleInformation;
  const { trackEvent } = useAnalytics();

  const onClick = () => {
    open(action.url);
    trackEvent({
      analyticEvent: ANALYTICS.EVENT.CLICKED_LINK,
      details: {
        analytic_click_id: `${CHAT_UI_PREFIX}-vehicle-information-card-more`,
        content: title,
        url: action.url,
      } as AnalyticClickedLinkDetailsType,
    });
  };

  return (
    <ViewMoreContainer onClick={onClick}>
      <Typography emphasis='regular' size='lg' color='currentColor'>
        {title}
      </Typography>
    </ViewMoreContainer>
  );
};

export default MoreLikeThisCard;
